import {
  Document,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
  Font,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import React, { useEffect, useRef } from "react";

// Font.register({
//   family: 'Courier Prime',
//   src: '/fonts/Courrier_Prime/CourierPrime-Regular.ttf',
// });

//   Font.register({
//   family: 'Liberation Mono',
//   src: '../..assets/Liberation-Mono/LiberationMono-Regular.ttf',
// });
// Font.register({
//   family: "Roboto",
//   src: "/fonts/Roboto/static/Roboto-Regular.ttf",
// });

const styles = StyleSheet.create({
  body : {
width: "80mm",
margin: 0,
padding:0,
  },
  page: {
    flexDirection: "column",
    alignItems: "center",
    // padding: 10,

  },
  receiptContainer: {
    width: 155,
    textAlign: "center",
    //   fontFamily: "Courier",
  },
  header: {
    fontSize: 7,
    fontWeight: "bold",
    marginBottom: 2,
  },
  text: {
    fontSize: 6,
  },

  textHeader: {
    fontSize: 6,
    textAlign: "left",
    paddingLeft: "8px",
  },
  line: {
    marginVertical: 3,
    borderBottom: "1px solid black",
  },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 6,
    paddingLeft: "8px",
    paddingRight: "8px",
    //   fontFamily: "Courier",
  },

  itemRowHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 6,
    paddingRight: "8px",

    //   fontFamily: "Courier",
  },

  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 6,
    fontWeight: "bold",
    fontFamily: "Roboto",
    paddingLeft: "8px",
    paddingRight: "8px",
    // fontFamily: "Courier",
  },
});

export default function ORPrint({ ORDetails }) {


  const hasPrinted = useRef(false);
  const transaction = ORDetails[0]; // actual order details
  const StoreInfo = ORDetails[1]; // store details


  // console.log(ORDetails);

  const subtotal =
    transaction?.productList?.reduce(
      (sum, item) =>
        sum + parseFloat(item.totalQty) * parseFloat(item.productPriceperkg),
      0
    ) || 0;

  const tax = subtotal * 0.12;
  const total = subtotal + tax;

  // const StoreInfo = ORDetails[ORDetails.length - 1];

  return (
    <PDFViewer style={{ width: "100%", height: "80vh" }}>
      <Document>
        <Page size={{ width: 160, height: "auto" }} style={styles.page}>
        {/* <Page size={{ width: 160, height: 300 }} style={styles.page}> */}
          <Text>{"\n"}</Text>
          <View style={styles.receiptContainer}>
            {/* Header */}
            <Text style={styles.header}>{StoreInfo?.name}</Text>
            {/* <View style={styles.line} /> */}
            <Text style={styles.text}>{StoreInfo?.address}</Text>
            {/* Transaction Details */}
            <Text style={styles.text}>
              CALL & TEXT: {StoreInfo?.contactNumber}
            </Text>
            <Text style={styles.text}>
              FB/MESSENGER: {StoreInfo?.fb_messenger}
            </Text>
            <Text style={styles.text}>
              CUSTOMER CARE HOTLINE: {StoreInfo?.cust_care_number}
            </Text>
            <Text style={styles.text}>SALES INVOICE</Text>

            <Text>{"\n"}</Text>

            {/* <Text style={styles.textHeader}>
              Ref# {transaction?.orderNumber || "0000000000"}
            </Text>
            <Text style={styles.textHeader}>
              SI# {ORDetails[2] || "0000000000"}
            </Text> */}

            <View style={styles.itemRowHeader}>
              <Text style={styles.textHeader}>
                Date: {dayjs().format("MM/DD/YYYY HH:mm:ss")}
              </Text>
              <Text style={styles.textHeader}>Cashier: {ORDetails[3]}</Text>
            </View>

            <View style={styles.itemRowHeader}>
              <Text style={styles.textHeader}>
                Ref#: {transaction?.orderNumber || "0000000000"}
              </Text>
              <Text style={styles.textHeader}>
                SI#: {ORDetails[2] || "0000000000"}
              </Text>
            </View>

            <View style={styles.line} />

            {/* Table Header */}
            <View style={styles.itemRow}>
              <Text style={{ width: "10%" }}>Qty</Text>
              <Text style={{ width: "50%" }}>Description</Text>
              <Text style={{ width: "20%", textAlign: "right" }}>Price</Text>
              <Text style={{ width: "20%", textAlign: "right" }}>Amount</Text>
            </View>
            <View style={styles.line} />

            {/* Items */}
            {transaction?.productList?.map((product, index) => (
              <View key={index} style={styles.itemRow}>
                <Text style={{ width: "10%" }}>{product.totalQty}</Text>
                <Text style={{ width: "50%" }}>{product.productDesc}</Text>
                <Text style={{ width: "20%", textAlign: "right" }}>
                  {product.productPriceperkg}
                </Text>
                <Text style={{ width: "20%", textAlign: "right" }}>
                  {(
                    parseFloat(product.totalQty) *
                    parseFloat(product.productPriceperkg)
                  ).toFixed(2)}
                </Text>
              </View>
            ))}

            <View style={styles.line} />

            {/* Summary */}
            <View style={styles.totalRow}>
              <Text>SUBTOTAL</Text>
              <Text>₱{subtotal.toFixed(2)}</Text>
            </View>
            <View style={styles.totalRow}>
              <Text>CASH</Text>
              <Text>₱{transaction?.amountpaid?.toFixed(2) || "0.00"}</Text>
            </View>
            {/* <View style={styles.line} /> */}

            <View style={styles.totalRow}>
              <Text>CHANGE</Text>
              <Text>₱{(transaction?.amountpaid - subtotal).toFixed(2)}</Text>
            </View>
            {/* <View style={styles.line} /> */}

            <Text style={styles.text}>
              TOTAL NO OF ITEMS: {transaction?.productList?.length}
            </Text>
            <View style={styles.line} />

            {/* VAT Breakdown */}
            <View style={styles.totalRow}>
              <Text>VAT SALES (V)</Text>
              <Text>₱{(subtotal / 1.12).toFixed(2)}</Text>
            </View>
            <View style={styles.totalRow}>
              <Text>VAT EXEMPT SALES (N)</Text>
              <Text>₱0.00</Text>
            </View>
            <View style={styles.totalRow}>
              <Text>VAT ZERO-RATED SALES (Z)</Text>
              <Text>₱0.00</Text>
            </View>
            <View style={styles.totalRow}>
              <Text>12% VAT SALES</Text>
              <Text>₱{(subtotal - subtotal / 1.12).toFixed(2)}</Text>
            </View>
            <View style={styles.line} />

            {/* Buyer Details */}
            {/* <Text style={styles.text}>BUYER NAME:</Text>
              <Text style={styles.text}>BUYER ADDRESS:</Text>
              <Text style={styles.text}>BUYER TIN:</Text>
              <Text style={styles.text}>BUSINESS STYLE:</Text>
              <View style={styles.line} /> */}

            {/* Footer */}
            {/* <Text style={styles.text}>POS Provider:</Text>
              <Text style={styles.text}>X-Gen Innovative Technologies Corp.</Text>
              <Text style={styles.text}>Angono City</Text>
              <Text style={styles.text}>TIN: 123456</Text>
              <Text style={styles.text}>Accred No.: 123456789</Text>
              <Text style={styles.text}>Date Issued: ___/___/____</Text>
              <Text style={styles.text}>PTU Number: ______</Text>
              <View style={styles.line} /> */}
            <Text>{"\n"}</Text>

            {/* <Text style={styles.text}>THIS INVOICE SHALL BE VALID FOR 5 YEARS</Text> */}
            <Text style={styles.text}>{StoreInfo?.footer_1}</Text>
            <Text style={styles.text}>{StoreInfo?.footer_2}</Text>

            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
}
